import { Component, EventEmitter, Output } from "@angular/core";
import { TicketTemplateService } from "@app2/ticket/shared/ticket-template.service";
import { TicketTemplate } from "@app2/type-defs/ticket/ticket-types";
import { byName } from "@app2/util/util";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "add-ticket-description-template-dropdown",
    template: `
        <pr-dropdown class="options-dropdown">
            <div class="align-dropdown link-dropdown" pr-dropdown-trigger>
                <span class="link-text">
                    <i class="fas fa-plus"></i>
                    {{ 'ADD_TICKET_DESCRIPTION_TEMPLATE' | localize }}
                    <i class="far fa-angle-down"></i>
                </span>
            </div>
            <ul pr-dropdown-body>
                <li *ngFor="let template of templates"
                    (click)="selected.emit(template)"
                    [attr.test-id]="'add-template-' + template.id">
                    {{ template.name }}
                </li>
            </ul>
        </pr-dropdown>
    `,
})
export class AddTicketDescriptionTemplateDropdownComponent {
    @Output() selected = new EventEmitter<TicketTemplate>();

    templates: TicketTemplate[] = [];

    constructor(private readonly templateService: TicketTemplateService) {
        templateService.getTemplates$()
            .pipe(untilDestroyed(this))
            .subscribe(templates => this.templates = templates.sort(byName()));
    }
}
